module.exports = __webpack_public_path__ + "img/gray-add-btn.d9307825.svg";